import L from "leaflet";

export const VenueIconDanger = L.icon({
  iconUrl: require("../../../../assets/location_danger.png"),
  iconSize: [38, 53]
});
